import { ComponentType } from '@wix/a11y-adapters';
import { dsClassicEditorDataModifier, dsStudioDataModifier } from '@wix/a11y-adapters/studio';
import Color from 'color';
import { isClassicEditorHost } from '../../../../utils/get-editor-host';
export const isClassicTextComponent = (type, editorHost) => {
  return isClassicEditorHost(editorHost) && type === ComponentType.Text;
};
export const isClassicPageComponent = (type, editorHost) => {
  return isClassicEditorHost(editorHost) && type === ComponentType.Page;
};
export const updateClassicTextColor = (component, color, setComponentData) => {
  const updatedText = dsClassicEditorDataModifier.updateTextComponentColor(component, color);
  const updatedData = {
    ...component.data,
    text: updatedText
  };
  updatedText && setComponentData(component.compRef, updatedData);
};
export const updateClassicTextAndBackgroundColor = (component, textColor, backgroundColor, setComponentData) => {
  const updatedText = dsClassicEditorDataModifier.updateTextAndBackgroundColor(component, textColor, backgroundColor);
  const updatedData = {
    ...component.data,
    text: updatedText
  };
  updatedText && setComponentData(component.compRef, updatedData);
};
export const updateClassicBackgroundColor = (component, color, setComponentData) => {
  const updatedText = dsClassicEditorDataModifier.updateTextComponentBackgroundColor(component, color);
  const updatedData = {
    ...component.data,
    text: updatedText
  };
  updatedText && setComponentData(component.compRef, updatedData);
};
export const updateClassicPageBackground = (component, color, setComponentData, setComponentStyle) => {
  const {
    data,
    style
  } = dsClassicEditorDataModifier.updateParentPageBackgroundColor(component, color);
  data && setComponentData(component.compRef, data);
  style && setComponentStyle(component.compRef, style);
};
export const updateStudioColor = (component, color, setComponentStyle, setComponentDesign) => {
  const {
    style,
    design
  } = dsStudioDataModifier.updateTextColor(component, color);
  style && setComponentStyle(component.compRef, style);
  design && setComponentDesign(component.compRef, design);
};
export const updateStudioBackgroundColor = (component, color, setComponentStyle, setComponentDesign) => {
  const {
    style,
    design
  } = dsStudioDataModifier.updateBackgroundColor(component, color);
  style && setComponentStyle(component.compRef, style);
  design && setComponentDesign(component.compRef, design);
};
export const updateStudioTextAndBackgroundColor = (component, textColor, backgroundColor, setComponentStyle) => {
  const {
    style
  } = dsStudioDataModifier.updateTextAndBackgroundColor(component, textColor, backgroundColor);
  style && setComponentStyle(component.compRef, style);
};
export const getFormattedColor = (type, color, alpha) => {
  return type === ComponentType.StylableButton ? new Color(color).alpha(alpha ?? 1).rgb().string() : color;
};
export const updateEditor3TextColor = (component, className, color, a11yWizardAdapter) => {
  const {
    setTextColorForBuilderComponent,
    isBuilderRichTextComponent,
    setTextColorForRichTextBuilderComponent
  } = a11yWizardAdapter;
  if (isBuilderRichTextComponent != null && isBuilderRichTextComponent(component.compRef)) {
    setTextColorForRichTextBuilderComponent == null || setTextColorForRichTextBuilderComponent(color);
  } else {
    setTextColorForBuilderComponent(component.compRef, className, color);
  }
};
export const updateEditor3BackgroundColor = (component, className, color, a11yWizardAdapter) => {
  const {
    setBackgroundForBuilderComponent,
    isBuilderRichTextComponent,
    setBackgroundForRichTextBuilderComponent
  } = a11yWizardAdapter;
  if (isBuilderRichTextComponent != null && isBuilderRichTextComponent(component.compRef)) {
    setBackgroundForRichTextBuilderComponent == null || setBackgroundForRichTextBuilderComponent(color);
  } else {
    setBackgroundForBuilderComponent(component.compRef, className, color);
  }
};
//# sourceMappingURL=update-elements-color-utils.js.map